// extracted by mini-css-extract-plugin
export default {"container":"Integrations_container__I6c5N","title":"Integrations_title__6dwdj","subtitle":"Integrations_subtitle__Hj3BC","list":"Integrations_list__YhASC"};